<template>
  <div>
    <b-modal ref="deliveryStatusModal" size="lg" :title="title">
      <form>
        <div class="form-group">
          <label class="form-label">{{ $t('table.header.delivery_status') }}</label>
          <multiselect
            v-model="status"
            :options="actions"
            :searchable="false"
            :showLabels="false"
            :close-on-select="true" 
            @select="onStatusChange">
            <template slot="option" slot-scope="{ option }">
                <span v-if="option === 'Delivery'" class="badge badge-warning">{{ getStatusLocalized('label.delivery') }}</span>
                <span v-if="option === 'Packaged'" class="badge badge-primary">{{ getStatusLocalized('label.packaged') }}</span>
                <span v-if="option === 'Delivered'" class="badge badge-success">{{ getStatusLocalized('label.delivered') }}</span>
            </template>
          </multiselect>
        </div>
        <br>
        <br>
        <br>
        <br>
        <br>
      </form>
      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <div class="d-flex">
            <b-button @click="close()">{{ $t('button_link.cancel') }}</b-button>
            <!-- <b-button class="ml-1" variant="primary" @click="submitForm">{{ $t('button_link.save') }}</b-button> -->
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import moment from 'moment'
import { insertLeadingZero } from './../../../../assets/js/dashboard/utilities.js'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'

export default {
  name: 'deliveryStatusForm',
  props: {
  },
  components: {
  },
  data() {
    return {
      actions: [
          'Delivery',
          'Packaged',
          'Delivered',
      ],

      title: '',
      salesID: '',
      status: '',
    }
  },
  watch: {
    "$i18n.locale"(val) {
    }
  },
  methods: {
    getStatusLocalized(t) {
        return this.$i18n.t(t) || t
    },

    setData(item) {
      this.title = this.$i18n.t('label.delivery') + ' #' + insertLeadingZero(item.receiptID)
      this.salesID = item.saleID
      this.status = ''
      this.$refs['deliveryStatusModal'].show()
    },

    onStatusChange(value) {
      let url = this.$api.BUSINESS_SALES + "/" + this.salesID + '/delivery/update'

      let data = {}
      if(value === 'Delivery') {
        data['deliveryDate'] = moment().unix()
      } else if(value === 'Packaged') {
        data['packageDate'] = moment().unix()
      } else if(value === 'Delivered') {
        data['deliveredDate'] = moment().unix()
      }

      let $vm = this
      $vm.$axios({
        method: 'post',
        url: url,
        baseURL: this.$api.API_ENDPOINT_ORDER,
        headers: { token: $vm.$session.get('token') },
        data: data,
      })
        .then((response) => {
          if (response.status == 200) {
            var action = $vm.$i18n.t('message.success.action.update')
            var message = $vm.$i18n.t('message.success.success', { 'action': action })
            $vm.$parent.$parent.$parent.setModal($vm, false, true, message);
          }
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          } else {
            $vm.$parent.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
          }
        })
    },

    closeModal(isError) {
      if(!isError) {
        this.$refs['deliveryStatusModal'].hide()
        this.$emit('onModalClose')
      }
    }
  },
  async mounted() {
    let $vm = this;
  }
}
</script>
<style scoped>
.show {
  display: block;
}

.nav-link,
.link {
  cursor: pointer;
}

.img-thumbnail {
  width: 20em;
}

.item-image {
  width: 8em;
  opacity: .5;
}

.error-validation {
  font-size: 0.6875rem;
  margin-top: 0.325rem;
  color: #fd3995;
}
</style>